/**
 * PlotError — fail-fast chrome for invalid plot fences.
 */

import { CHAT_EMBED_PROPS } from '../../embeds/chat-embed.js';

interface PlotErrorProps {
  message: string;
}

export function PlotError({ message }: PlotErrorProps) {
  return (
    <div
      {...CHAT_EMBED_PROPS}
      data-plot-embed
      className="my-3 w-full rounded-lg border border-red-300 bg-red-50 px-3 py-2 text-sm text-red-900 dark:border-red-800 dark:bg-red-950/40 dark:text-red-100"
      role="alert"
    >
      <div className="font-medium">Invalid plot block</div>
      <div className="mt-0.5 opacity-90">{message}</div>
    </div>
  );
}

PlotError.displayName = 'PlotError';
